export const UPLOAD_SIZE = 1600;
export const UPLOAD_LOW_SIZE = 920;
export const UPLOAD_MIN_IMAGES = 25;
export const UPLOAD_MAX_IMAGES = 864;
export const UPLOAD_THUMB_QUALITY = 0.9;
export const UPLOAD_TOP_BAR_HEIGHT = 70;
export const UPLOAD_DELETE_POPUP_WIDTH = 280;
export const THUMB_SIZE = 200;
export const SWIPER_TOUCH_ANGEL = 15;

//export const LOGIN_URL = 'https://connect.lupa.co/login?channel=online&token=';
// export const LOGIN_URL = 'https://connect.lupa.co/v2/ui/index.aspx?channel=online&callback=iframe&token=';
//export const LOGIN_URL = 'https://connect.lupa.co/v2/ui/index.aspx?channel=online&callback=iframe&temptoken=';
export const LOGIN_URL = 'https://connect-v2-ui.lupa.co.il/loginregister?channel=online&temptoken=';
export const LOGOUT_URL = 'https://connect.lupa.co.il/logout?channel=online&token=';
export const SHIPMENT_URL = 'https://www.lupa.co.il/About/shipping-guidelines';
export const EDITOR_API_URL = 'v3/editor-browser.aspx';
export const CHECKOUT_API_URL = 'v1o/ajax/onlineApi.aspx';
export const BROWSER_API_URL = 'v3/api-browser.aspx';
export const EVENTS_API_URL = 'v3/events-browser.aspx';
export const USER_API_URL = 'api.aspx';
export const CONNECT_API = 'v2/api/entry.aspx';
export const TERM_STORAGE = 'acceptTerms';
export const LICENSE_VERSION = 'licenseVersion'
export const LUPA_TOKEN_STORAGE = 'LUPA_TOKEN';
export const LUPA_VERSION_STORAGE = 'LUPA_VESION';
export const LUPA_IS_TMP_TOKEN = "LUPA_TMP_TOKEN";
export const ERROR_MINIMUM_IMAGE_COUNT = 'ERROR_MINIMUM_IMAGE_COUNT';
export const BOOK_NAME_MAX = 28;
export const AUTOSAVE_TIMER = 5000;
export const PAGE_BASE_TITLE = 'לופה';
export const LOADER_LINK = '/assets/loader/lupa_loading1_HTML5 Canvas.html';
export const RECONNECT_TO_GOOGLE_MESSAGE = 'יש להתחבר לגוגל שוב';
export const ERROR_ACCESS_DENIED = 'ERROR_ACCESS_DENIED';
export const IMAGE_JPEG = 'image/jpeg';
export const ANONYMOUS = 'Anonymous';
export const CROSSORIGIN = 'crossOrigin';
export const SMALL_HEIGHT_BREAK_POINT = 500;
export const HEADER_HEIGHT = '50px';
export const SNACKBAR_INTERVAL = 3000;
export const SIZE_MEDIUM = 'size=medium';
export const SIZE_THUMB = 'size=thumb';
export const WHITE_COLOR = '#ffffff';
export const BLACK_COLOR = 'black';
export const RESIZE_IMAGE_QUALITY = 0.8;
export const ERROR_THEMES_LOCKED_INJECTION_BOOK = 'ERROR_THEMES_LOCKED_INJECTION_BOOK';
export const CONFIRM_SPREAD_DELETE_WIDTH = '600px';
export const CONFIRM_EDITOR_ADD_WIDTH = '400px';
export const CONFIRM_BOOK_WIDTH = '600px';
export const PAGE_VIEW = 'page_view';

export enum UPLOAD_PROVIDERS {
    Local = 1,
    Facebook = 2,
    Google = 3,
    Dropbox = 4,
    Instagram = 5,
}

export enum PRINT_QUALITY {
    NO_PRINTABLE = -1,
    LOW_QUALITY_PRINT = -2,
    HIGH_QUALITY_PRINT = 0,
}
export enum BOOK_FORMATS {
    SMALL_BOOK_FORMAT = 27,
    BIG_BOOK_FORMAT = 35,
}
export enum UPLOAD_IMAGE_STATUS {
    ACTIVE = 1,
    UPLOADING = 2,
    UPLOADED = 3,
}
export const NAVIGATION_ARRAY = [
    '/create/naming',
    // '/create/regulations',
    '/create/upload',
    '/create/theme',
    '/create/layout',
    '/editor',
    '/checkout/format',
    '/checkout/cover',
    '/checkout/copies',
];
